import { Inject, Injectable, REQUEST_CONTEXT, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, ROUTES, Router, Routes } from '@angular/router';

import { VnRequestContext } from '@frontend/vanilla/ssr';

import { OnAppInit } from '../bootstrap/bootstrapper.service';
import { Page } from '../client-config/page.client-config';
import { LoadingIndicatorHandler } from '../loading-indicator/loading-indicator-handler';
import { LoadingIndicatorService } from '../loading-indicator/loading-indicator.service';
import { RouteProcessorService } from './route-processor.service';

@Injectable()
export class RoutingBootstrapService implements OnAppInit {
    private handlersByNavigationId = new Map<number, LoadingIndicatorHandler>();
    private requestContext = inject<VnRequestContext>(REQUEST_CONTEXT);
    private page = inject(Page);

    constructor(
        private readonly router: Router,
        private readonly loadingIndicatorService: LoadingIndicatorService,
        private readonly routeProcessorService: RouteProcessorService,
        @Inject(ROUTES) private readonly routes: Routes[],
    ) {}

    onAppInit() {
        this.requestContext?.logger?.info?.({ config: [...this.router.config], routes: this.routes, page: this.page }, 'router config before reset');
        this.router.resetConfig(this.routeProcessorService.processRoutes(this.routes));
        this.requestContext?.logger?.info?.({ config: [...this.router.config], routes: this.routes, page: this.page }, 'router config after reset');
        this.router.events.subscribe((e) => {
            if (e instanceof NavigationStart) {
                const handler = this.loadingIndicatorService.start({
                    url: e.url,
                });
                this.handlersByNavigationId.set(e.id, handler);
            } else if (e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError) {
                const handler = this.handlersByNavigationId.get(e.id);
                if (handler) {
                    handler.done();
                    this.handlersByNavigationId.delete(e.id);
                }
            }
        });
    }
}
